<div class="section-title">Maintenance History for {{asset.asset_name}}</div>

@if (logs === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading logs...
	</div>
}

@if (logs && !logs.length) {
	<div class="loading-status">
		No maintenance logs have been entered
	</div>
}

@if (logs && logs.length) {
	<table class="log compact">
		<thead>
			<tr>
				<th>Date</th>
				<th>Entered by</th>
				<th>LRU</th>
				<th>Summary</th>
				@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
					<th>
						Delete</th>
				}
			</tr>
		</thead>
		@for (log of logs; track log) {
			<tbody>
				<tr>
					<td>{{log.ts | datetime : "offset" : asset.time_offset_hours }}</td>
					<td>{{log.author_email}}</td>
					<td>{{lookupLRU(log.lru)}}</td>
					<td [innerHTML]="log.user_note | escapehtml | linkify | multiline"></td>
					@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
						<td>
							<app-action-button [action]="DeleteMaintenance" [args]="[log.maintenance_history_id]" [context]="this" btnClass="icon red" confirm="Are you sure?" processing="..."><i
									class="icon-trash"></i></app-action-button>
						</td>
					}
				</tr>
			</tbody>
		}
	</table>
}

<div class="panel" [hidden]="this.api.user?.role === 'readonly'">
	<div class="heading">Record new maintenance event</div>
	<div class="content">
		<div class="row">
			<div class="col-lg-6">
				@if (asset.is_fixed) {
					<p>Date of event:</p>
					<app-day-picker [(ngModel)]="newDate"></app-day-picker>
				}
				@if (!asset.is_fixed) {
					<label>Last operation before maintenance:</label>
					@if (operations === undefined) {
						<select class="form-control form-control-sm" disabled>
							<option>Loading operations...</option>
						</select>
					}
					@if (operations !== undefined) {
						<select class="form-control form-control-sm op-list" [(ngModel)]="selectedOperation"
							title="Showing {{ operations && operations.length >= RECENT_OPERATIONS_LIMIT ? 'latest ' + RECENT_OPERATIONS_LIMIT : 'all' }} operations with a known end time">
							@for (operation of operations; track operation) {
								<option [ngValue]="operation" [class]="GetOpClass(operation)">
									{{operation | operationlabel : (fleet ? fleet.time_offset_hours : 0) : true : true}}
								</option>
							}
						</select>
					}
				}
				<p class="mt-4">LRU affected:</p>
				@for (lru of allLRUs; track lru) {
					<div class="form-check">
						<label>
							<input type="radio" name="lruRadios" [value]="lru" [(ngModel)]="newLRU">
							{{lru.name}}
						</label>
					</div>
				}
			</div>
			<div class="col-lg-6">
				<div class="mb-3">
					<label>Event summary:</label>
					<div>
						<textarea [(ngModel)]="newSummary" class="form-control" style="min-height: 150px;"></textarea>
					</div>
				</div>
				<app-action-button [action]="UploadMaintenance" [context]="this" btnClass="green" [disabled]="!(selectedOperation || newDate) || !newSummary" processing="Saving..."
					complete="Maintenance recorded">Record maintenance event</app-action-button>
			</div>
		</div>
	</div>
</div>